'use client';

var _effectorFileName = "/src/widgets/layouts/main/pricing/pricing.tsx";
import { useState } from 'react';
import { GradientBg } from '@/shared/components/animation/gradient-background';
import { Article } from '@/shared/components/article';
import { Tabs, TabsList, TabsTrigger } from '@/shared/components/ui/tabs';
import { cn } from '@/shared/lib/cn';
import { ServiceItem } from '../constants/services-list';
import { BILLING_PERIODS, type Periods } from './constants';
import { PricingCard } from './pricing-card';
interface PricingProps {
  servicesList: ServiceItem[];
}
export const Pricing = ({
  servicesList
}: PricingProps) => {
  const [billingPeriod, setBillingPeriod] = useState<(typeof BILLING_PERIODS)[keyof typeof BILLING_PERIODS]>(BILLING_PERIODS.TWO_MONTHS);
  return <Article>
      <div className="mb-4 text-center sm:mb-12">
        <h2 className="mx-auto mb-2 text-3xl font-medium sm:mb-4 sm:text-5xl">Форматы обучения</h2>

        <p className="mx-auto text-base text-muted-foreground sm:text-lg sm:leading-8">
          Поможем вам подобрать удобный формат, чтобы выучить язык для любых целей
        </p>
      </div>

      <div className="relative mb-12 flex items-center justify-center">
        <Tabs value={billingPeriod} onValueChange={value => setBillingPeriod(value as Periods)} className="relative flex justify-center">
          <TabsList className="grid w-max grid-cols-2 rounded-2xl bg-gray-200 dark:bg-muted">
            <TabsTrigger value={BILLING_PERIODS.BASIC} className="w-full min-w-0 rounded-xl data-[state=active]:bg-brand-accent-dark data-[state=active]:text-white">
              Месяц
            </TabsTrigger>
            <TabsTrigger value={BILLING_PERIODS.TWO_MONTHS} className="w-full min-w-0 rounded-xl data-[state=active]:bg-brand-accent-dark data-[state=active]:text-white">
              2 месяца
            </TabsTrigger>
          </TabsList>

          <span className={cn('absolute -right-9 top-full inline-flex items-center justify-center whitespace-nowrap rounded-xl border border-brand-accent-dark bg-brand-accent-superLight px-2 py-1 font-mono text-xs tabular-nums text-black/80', {
          'border-gray-300 bg-gray-100 text-gray-400': billingPeriod === BILLING_PERIODS.BASIC
        })}>
            Выгоднее на 10%
          </span>
        </Tabs>
      </div>

      <div className="relative mx-auto grid w-full max-w-lg grid-cols-1 items-center justify-items-stretch gap-4 md:max-w-5xl md:grid-cols-[1fr_1.12fr_1fr] md:gap-0">
        {servicesList.map((service, index) => <PricingCard key={index} header={service.header} description={service.description} prices={'prices' in service && service.prices ? {
        current: service.prices[billingPeriod],
        prev: (service.prices.prev as Partial<Record<Periods, number>> | undefined)?.[billingPeriod]
      } : undefined} benefitsList={service.benefitsList} isServicePrimary={service.isServicePrimary} link={service.link} isExternalLink={service.isExternalLink} />)}

        <GradientBg className="hidden md:block" type="circle" origin="center" size={400} />
      </div>
    </Article>;
};